import { type ReactElement, type ReactNode } from 'react';
import { Navigate } from 'react-router';
import { useAuth } from '../lib/auth-context';

interface PrivateRouteProps {
	children: ReactNode;
}

function PrivateRoute({ children }: PrivateRouteProps): ReactElement {
	const { isLoggedin } = useAuth();
	return isLoggedin ? <>{children}</> : <Navigate to='/login' replace />;
}

export default PrivateRoute;
